import styled from 'styled-components'
import { Link as RouterLink } from 'react-router-dom'

export const FullPage = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const Header = styled.h1`
    font-size: 58px;
    color: rgba(255, 255, 255, 0.25);
    padding: 0;
    margin: 0;
`

export const Paragraph = styled.p`
    margin: 20px 0 0;
    color: rgba(255, 255, 255, 0.25);
`

export const Link = styled(RouterLink)`
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;

    &:hover {
        border-bottom: 1px solid white;
    }
`



// WEBPACK FOOTER //
// ./src/pages/PageNotFound.styles.js